function reinitOneclick() {
  setTimeout(() => {
    window.ProductShop.init();
    window.ProductOneclick.init();
  }, 1500);
}
  
let mainTarget = document.querySelector('#searchspring-content'); //target your element here
let config = { attributes: true, childList: true, subtree: false }; //you may need 'subtree: true' but keep performance effects in mind
let callback = function(mutationsList, observer) {
  for(var mutation of mutationsList) {
    if (mutation.type == 'childList') {
      $(document).on("click", "#searchspring-content .tab-button", function() {
        reinitOneclick();
      });
      reinitOneclick();
      observer.disconnect();
    }
  }
};
let observer = new MutationObserver(callback);
observer.observe(mainTarget, config);